import { mapState, mapMutations } from "vuex";

import * as apis from "@/api";
import { conversion, GetItemDuration } from "@/tool";
import { format_case_name } from "@/filters/format_case_name";

import open_sound from "@/assets/audio/unlock.mp3";
import run_sound from "@/assets/audio/roll.mp3";
import win_sound from "@/assets/audio/battlewin.ogg";
import lose_sound from "@/assets/audio/lose.ogg";

import Picture from "@/components/picture";
import Button from "@/components/button";
import BlockTitle from "@/components/block_title";
// import Award from "@/components/award";
import InteractivePanel from "@/components/interactive_panel";

// import CaseOpening from '@/partials/case_opening/single.vue';
// import CaseOpeningMore from "@/partials/case_opening/more.vue";
import CustomButton from "@/partials/custom_button";
import { CustomBlockTitle } from "@/partials/custom_block_title";

import liveDropBox from "@/partials/live_drop_box";
import awardAverageExtraCaseItem from "@/components/awardAverageExtraCaseItem/index.vue";
import {
  RewardModal,
  CaseOpening,
  CaseOpeningMore,
  Award,
} from "@/components/UI";
import UnpackgameInstanceItem from "@/components/UnpackgameInstanceItem";

export default {
  components: {
    "p-case-opening": CaseOpening,
    "p-case-opening-more": CaseOpeningMore,
    "p-custom-button": CustomButton,
    "p-custom-block-title": CustomBlockTitle,
    "c-picture": Picture,
    "c-button": Button,
    "c-block-title": BlockTitle,
    "c-award": Award,
    "c-interactive-panel": InteractivePanel,
    "p-liveDropBox": liveDropBox,
    "c-RewardModal": RewardModal,
    "c-awardAverageExtraCase-item": awardAverageExtraCaseItem,
    "c-unpackgameInstance-item": UnpackgameInstanceItem,
  },
  filters: {
    conversion,
    format_case_name,
    GetItemDuration,
  },
  data() {
    return {
      /** 箱子信息 */
      case_info: {},

      /** 箱子奖品列表 */
      case_awards: [],

      /** 箱子奖品列表 */
      drop_awards: [],

      /** 开箱获得奖品列表 */

      case_opened_awards: [],

      caseListPannelActive: 0,
      /** 开箱个数 */
      case_open_number: 1,

      /** 是否跳过开箱动画 */
      is_jump_case_open_animation: false,

      /** 是否为开箱试玩 */
      is_case_open_try: false,

      /** 开箱CDK */
      case_open_cdk: "",

      /** cdk开箱模态框显示 */
      is_case_open_cdk_modal_show: false,

      /** 开箱是否正在运行 */
      isRunning: false,

      /** 奖品模态框显示 */
      awards_modal_flag: false,

      /** 音乐 */
      sounds: [],

      notice_modal_show: false,
      awardAverageExtraCases: [],
      gameInstance_info: {},
      unpackgameInstance_item_show: false,
      mpcCaseSettings: {},
      mpcCaseTimer: null, // 用于存储计时器对象
    };
  },
  computed: {
    ...mapState(["user", "config", "isMute"]),

    /** 开箱成本价 */
    case_open_amount: (vm) => {
      let price = vm.case_info.price;
      if (vm.isHappyCoin && vm.case_info.happyCoinPrice) {
        price = vm.case_info.happyCoinPrice;
      }
      return price * vm.case_open_number;
    },

    isUsingHappyCoin() {
      return this.isHappyCoin && this.case_info.happyCoinPrice;
    },

    case_header_title() {
      if (!this.case_info.caseName) {
        return "";
      }
      if (Number(this.case_info.useType) !== 88 || !this.case_info.creatorName) {
        return this.case_info.caseName;
      }
      return `${this.case_info.caseName} - ${this.case_info.creatorName}`;
    },

    /** 开箱结果奖品金额合计 */
    case_opened_awards_amount: (vm) =>
      vm.case_opened_awards
        .filter((_) => !_.isConvert)
        .reduce((acc, { price }) => acc + price, 0),

    /** 开箱结果盈利比率 */
    case_opened_profit_ratio: (vm) => {
      if (
        vm.case_open_amount <= 0 ||
        vm.case_opened_awards_amount < vm.case_open_amount
      )
        return 0;

      const profit = vm.case_opened_awards_amount;

      const profit_ratio = profit / vm.case_open_amount;

      return profit_ratio;
    },

    /** 快标题宽度 */
    block_title_width: (vm) => (vm.$screen.mobile ? "100%" : "44%"),

    calcViewRate() {
      return function (rate) {
        return (
          Math.round(
            (rate /
              this.case_awards.map((_) => _.viewRate).reduce((a, b) => a + b)) *
            1000000
          ) / 10000
        );
      };
    },
  },

  watch: {},

  async beforeRouteUpdate(to, from, next) {
    await next();
    await this.get_case_info();
  },
  async mounted() {
    this.countdownHandle();
  },
  async created() {
    this.is_jump_case_open_animation =
      sessionStorage.getItem("is_jump_case_open_animation") === "true";

    var sounds = {
      open: new Audio(open_sound),
      run: new Audio(run_sound),
      win: new Audio(win_sound),
      lose: new Audio(lose_sound),
    };

    this.sounds = sounds;

    await this.get_case_info();
    //刚进入盲盒判断是否存在盲盒概率
    await this.getAwardAverageExtraCases();
    //判断合开开箱倒计时，刷新是否显示
    await this.getMPCaseSettings();
  },
  beforeDestroy() {
    if (this.mpcCaseTimer) {
      clearInterval(this.mpcCaseTimer);
    }
  },
  methods: {
    ...mapMutations(["setSpinShow"]),
    ...mapMutations(["setloginModal", "setPayModal"]),

    conversion,
    format_case_name,

    async getCaseDropList() {
      const cases_opened_response = await apis.indexHistory({
        caseId: this.case_info.caseId,
      });
      this.drop_awards = [];
      cases_opened_response.data.data.list.forEach((item, index) => {
        // console.log("insert drop data" + item.item.name);
        // this.drop_awards.push(
        //   this.case_awards.find((_) => _.itemname === item.item.name)
        // );
        const foundItem = this.case_awards.find(
          (_) => _.itemname === item.item.name
        );
        if (foundItem !== undefined) {
          this.drop_awards.push(foundItem);
        }
      });
      // console.log("dropList:");
      // console.log(this.drop_awards);
    },

    /** 跳过开箱动画 切换  */
    async toggle_is_jump_case_open_animation() {
      sessionStorage.setItem(
        "is_jump_case_open_animation",
        String(this.is_jump_case_open_animation)
      );
    },

    /** 切换CDK开箱模态显示状态 */
    async toggle_case_open_cdk_modal_show() {
      // 未登录处理
      if (!this.is_case_open_cdk_modal_show && !this.user.nickname) {
        this.setloginModal(true);

        return;
      }
      this.is_case_open_cdk_modal_show = !this.is_case_open_cdk_modal_show;
    },

    /** 获取箱子信息 */
    async get_case_info() {
      // 如果 URL 参数中有 userCase=1，调用 UserCase/Detail 接口；否则使用原来的接口
      const isUserCase = this.$route.query.userCase === '1' || this.$route.query.userCase == 1;
      const caseId = this.$route.params.id;
      let case_info_response = isUserCase 
        ? await apis.getUserCaseDetail(caseId)
        : await apis.api_CaseDetail(caseId);
      this.setSpinShow(false);
      if (case_info_response.data.code !== 0) {
        return;
      }

      const respone = case_info_response.data.data;

      this.case_info = respone.caseInfo;
      this.case_awards = respone.items;
      var currentTotal = 0;
      var totalRate = this.case_awards
        .map((_) => _.viewRate)
        .reduce((a, b) => a + b, 0);

      this.case_awards.forEach((item, index) => {
        // User requested raw values without scaling
        // Example: 10, 20, 30 -> 1-10, 11-30, 31-60

        // Calculate Range based on raw viewRate
        // Ensure we handle potential floats gracefully if they exist, 
        // but primarily trust the user's integrity of "actual values"
        let weight = Number(item.viewRate);

        // Fix precision for floats just in case
        let start = Number((currentTotal + (weight > 0 ? 0.01 : 0)).toFixed(2));
        // Logic check: User example 1-10.
        // If start 0. current 0. weight 10.
        // 1 to 10.
        // Next: start 11. weight 20. 
        // 11 to 30.

        // If I use (start + ?).
        // Integer logic:
        // start = currentTotal + 1;
        // currentTotal += weight;
        // end = currentTotal;

        // What if weight is 0.5?
        // current 0. weight 0.5.
        // start 0.01? end 0.50.
        // Next weight 0.5.
        // start 0.51? end 1.00.

        // Let's try to support both integers and reasonable floats.
        // If weights are integers, `start` should be integer.
        // If weights are floats, `start` should be float.

        let startVal, endVal;

        if (Number.isInteger(item.viewRate) && Number.isInteger(currentTotal)) {
          startVal = currentTotal;
          currentTotal += item.viewRate;
          endVal = currentTotal - 1;
          this.$set(item, 'rollRangeStr', `${startVal}-${endVal}`);
        } else {
          // Float case
          // current 0. weight 0.5. -> 0.01 - 0.50
          // current 0.5. weight 0.3. -> 0.51 - 0.80
          // Using 0.01 as smallest unit (assuming 2 decimal places max for rates usually)

          // BUT user said "actual values". 
          // If actual values are 0.05.
          // Maybe best to just show start-end? 
          // "0 - 10"? No, "1-10".
          // "10 - 30"? No, "11-30".

          // I will stick to the logic that worked for integers and apply 2 decimals for floats.
          // Precision update:
          let s = currentTotal;
          let e = currentTotal + weight;
          currentTotal = e;

          // Formatting
          // For start, we want "previous end + epsilon"? 
          // Or just use ranges (0, 10], (10, 30].
          // User notation "1-10" implies (0, 10]. 1 inclusive.
          // "11-30" implies (10, 30]. 11 inclusive.

          // If floats: 0-10.5? 10.5-20.5?
          // Let's just output `start + epsilon` to `end`.

          // Since I don't know the precision in float case:
          // I will try to detect integer-ness.
          this.$set(item, 'rollRangeStr', `${(s + (Number.isInteger(s) ? 0 : 0.01)).toFixed(Number.isInteger(s) ? 0 : 2)}-${e.toFixed(Number.isInteger(e) ? 0 : 2)}`);
        }

        // Restore percentage display
        // Calculate percentage: (weight / totalRate) * 100
        item.viewRate = Math.ceil((weight / totalRate) * 10000000) / 100000;
      });

      if (this.case_info.isShowHistory) {
        setTimeout(() => {
          this.getCaseDropList();
        }, 500);
      }
      //如果有副本箱
      if (this.case_info.isEnableAccumulateCase) {
        const gameInstance_response = await apis.api_CaseDetail(
          this.case_info.accumulateExtraCaseId
        );
        const respone = gameInstance_response.data.data;
        this.gameInstance_info = respone.caseInfo;
        this.case_info.accumulateCaseRoundCount = parseInt(
          this.case_info.accumulateCaseRoundCount
        );
        this.case_info.accumulateCaseRate = parseInt(
          this.case_info.accumulateCaseRate
        );
        this.gameInstance_info["isGameInstanceOpen"] = false;
        if (
          this.case_info.awardAccumulateExtraCases &&
          this.case_info.awardAccumulateExtraCases.length > 0
        ) {
          this.gameInstance_info["isGameInstanceOpen"] = true;
        } else {
          this.gameInstance_info["isGameInstanceOpen"] = false;
        }
        // console.log("进来没", this.gameInstance_info.isGameInstanceOpen);
      }
    },
    async getMPCaseSettings() {
      const response = await apis.getMPCaseSettings();
      if (response.data.code !== 0) {
        return;
      }
      this.mpcCaseSettings = response.data.data;
      this.mpcCaseSettings.mpCaseEndTime = new Date(this.mpcCaseSettings.mpCaseEndTime).getTime();
    },
    countdownHandle() {
      this.mpcCaseTimer = setInterval(() => {
        const now = Date.now();
        const end = new Date(this.mpcCaseSettings.mpCaseEndTime).getTime();
        const diff = end - now;
        if (diff <= 0) {
          clearInterval(this.mpcCaseTimer);
          // 倒计时结束
          this.getMPCaseSettings();
          return;
        }
      }, 1000);
    },
    /** 模拟开箱 */
    async case_open_emu() {
      if (this.isRunning)
        //如果开箱为运行状态则不运行
        return;

      this.is_case_open_try = true; //设置为试玩

      this.isRunning = true; //设置状态

      var sortArray = this.case_awards.slice();

      sortArray.sort(function (a, b) {
        return a.viewRate - b.viewRate;
      });

      var rditemList = [];
      var toatalRate = sortArray
        .map((_) => _.viewRate)
        .reduce((a, b) => a + b, 0);

      for (var i = 0; i < this.case_open_number; i++) {
        rditemList.push(sortArray[sortArray.length - 1]);

        for (var z = 0; z < sortArray.length; z++) {
          var rdnum = Math.floor(Math.random() * toatalRate);
          if (rdnum <= sortArray[z].viewRate) {
            rditemList[i] = sortArray[z];
            break;
          }
        }
      }

      // 处理奖品数组
      this.case_opened_awards = rditemList;

      this.case_opened_awards.forEach((item, index) => {
        this.$set(item, "isConvert", false);
        this.$set(item, "converting", false);
      });

      if (this.case_open_number <= 1) {
        this.$refs.case_opening_box.start(this.case_opened_awards[0]); //开箱开始运行
      } else {
        this.$refs.case_opening_box_more.start(this.case_opened_awards); //开箱开始运行
      }

      this.playStartAudio();
    },
    /**  真实开箱 */
    async case_open(type) {
      // 未登录处理
      if (!this.user.nickname) {
        this.setloginModal(true);
        return;
      }

      if (this.isRunning)
        //如果开箱为运行状态则不运行
        return;

      this.is_case_open_try = false; //设置不为试玩

      this.isRunning = true; //设置状态
      
      // 检查是否为自建箱子（userCase=1）
      const isUserCase = this.$route.query.userCase === '1' || this.$route.query.userCase == 1;
      
      // 如果是自建箱子，使用 UserCase/OpenCase 接口
      if (isUserCase && type === 'normal') {
        const params = {
          id: this.case_info.caseId || this.$route.params.id,
          // parentId: this.case_info.parentId || 0,
          count: this.case_open_number,
          useHappyCoin: false,
        };
        
        // 如果使用欢乐豆
        // if (this.isHappyCoin && this.case_info.happyCoinPrice) {
        //   params.useHappyCoin = true;
        // }
        
        const case_opened_response = await apis.userCaseOpenCase(params);
        
        // 开箱失败
        if (case_opened_response.data.code !== 0) {
          this.$toast.error(case_opened_response.data.msg);
          
          if (case_opened_response.data.msg.indexOf("充值") > -1) {
            this.setPayModal(true);
          }
          this.isRunning = false; //设置状态
          return;
        }
        
        // 处理奖品数组
        this.case_opened_awards = case_opened_response.data.data;
        
        this.case_opened_awards.forEach((item, index) => {
          this.$set(item, "isConvert", false);
          this.$set(item, "converting", false);
        });
        
        this.$store.commit("setInfo");
        
        await this.$nextTick();
        
        if (this.case_open_number <= 1) {
          this.$refs.case_opening_box.start(this.case_opened_awards[0]); //开箱开始运行
        } else {
          this.$refs.case_opening_box_more.start(this.case_opened_awards); //开箱开始运行
        }
        
        this.playStartAudio();
        return;
      }
      
      // 原有的开箱接口选择
      const case_opened_api = {
        normal: apis.userOpenMany,
        cdk: apis.userOpen_cdk,
      }[type];

      const params = {
        normal: {
          id: this.case_info.caseId,
          count: this.case_open_number,
        },
        cdk: {
          id: this.case_info.caseId,
          cdkey: this.case_open_cdk,
        },
      }[type];

      if (this.isHappyCoin && this.case_info.happyCoinPrice) {
        params.useHappyCoin = true;
      }

      const case_opened_response = await case_opened_api(params);

      // 开箱失败
      if (case_opened_response.data.code !== 0) {
        this.$toast.error(case_opened_response.data.msg);

        if (case_opened_response.data.msg.indexOf("充值") > -1) {
          this.setPayModal(true);
        }
        this.isRunning = false; //设置状态
        return;
      }

      // 处理奖品数组
      this.case_opened_awards = case_opened_response.data.data;

      this.case_opened_awards.forEach((item, index) => {
        this.$set(item, "isConvert", false);
        this.$set(item, "converting", false);
      });

      if (type == "cdk") this.toggle_case_open_cdk_modal_show();

      this.$store.commit("setInfo");

      await this.$nextTick();

      if (this.case_open_number <= 1) {
        this.$refs.case_opening_box.start(this.case_opened_awards[0]); //开箱开始运行
      } else {
        this.$refs.case_opening_box_more.start(this.case_opened_awards); //开箱开始运行
      }

      this.playStartAudio();
    },
    playStartAudio() {
      if (!this.isMute && !this.is_jump_case_open_animation) {
        this.sounds["open"].currentTime = 0;
        this.sounds["open"].play();
        this.sounds["run"].currentTime = 0;
        this.sounds["run"].playbackRate = 1.8;
        this.sounds["run"].play();
      }
    },
    /** 开箱结束事件 */
    async on_case_opened() {
      this.isRunning = false; //设置开箱运行状态
      this.awards_modal_flag = true;

      await this.$refs.case_reward_ui.reset();

      await this.case_opened_awards.forEach((item, index) => {
        this.$refs.case_reward_ui.pushItem(
          item.itemname,
          item.mSerial,
          item.itempic,
          item.rarity,
          item.price,
          item.roll
        );
      });

      // 刷新当前箱子信息
      await this.get_case_info();

      if (!this.isMute) {
        if (
          this.case_opened_awards.filter((_) => _.price > this.case_info.price)
            .length > 0
        ) {
          this.sounds["win"].currentTime = 0;
          this.sounds["win"].play();
        } else {
          this.sounds["lose"].currentTime = 0;
          this.sounds["lose"].play();
        }
      }

      await this.$refs.case_reward_ui.show();
      //查看是否有概率副本箱
      await this.getAwardAverageExtraCases();
      this.$refs.case_reward_ui.isShow = true;
    },
    //查看是否有概率副本箱
    getAwardAverageExtraCases() {
      // console.log('this.case_info=',this.case_info)
      this.awardAverageExtraCases = [];
      if (
        this.case_info.isEnableAverageCase &&
        this.case_info.awardAverageExtraCases &&
        this.case_info.awardAverageExtraCases.length > 0
      ) {
        let newArray = [];
        this.case_info.awardAverageExtraCases.forEach((ress) => {
          let obj = {
            extraCaseId: ress.extraCaseId,
            muxiangCaseId: this.case_info.caseId,
          };
          newArray.push(obj);
          if (Number(ress.allowOpenCount) > 1) {
            for (
              let index = 0;
              index < Number(ress.allowOpenCount - 1);
              index++
            ) {
              newArray.push(obj);
            }
          }
        });
        setTimeout(() => {
          newArray.forEach((res, resIndex) => {
            let obj = {
              ...res,
              awardAverageExtraCaseIndex: resIndex,
              isAwardAverageExtraCaseShow: resIndex == 0 ? true : false,
            };
            // console.log('resIndex==',resIndex)
            // console.log('obj==',obj)
            this.awardAverageExtraCases.push(obj);
          });
          // console.log(
          //   "this.awardAverageExtraCases==",
          //   this.awardAverageExtraCases
          // );
        }, 200);
      }
    },
    /** 开箱奖品折现 */
    async case_opened_awards_discount(award) {
      var awards_Serial = this.case_opened_awards.map((award) => award.mSerial);

      if (award) {
        awards_Serial = [award.mSerial];
      }

      this.case_opened_awards.forEach((item, index) => {
        if (awards_Serial.indexOf(item.mSerial) > -1) {
          item.converting = true;
        }
      });

      const awards_discount_response = await apis.api_SellItem({
        lstmSerial: awards_Serial,
      });

      // 折现失败
      if (awards_discount_response.data.code !== 0) {
        this.$toast.error(awards_discount_response.data.msg);
        return;
      }

      //this.awards_modal_flag = false;

      this.$toast.success(awards_discount_response.data.msg);

      // 更新用户信息
      this.$store.commit("setInfo");

      this.case_opened_awards.forEach((item, index) => {
        if (awards_Serial.indexOf(item.mSerial) > -1) {
          item.isConvert = true;
        }
      });
    },
    async ongameInstanceRewardCloseHandle(obj) {
      if (obj.data.isRewardShow) return;
      if (obj.data.boxType == "accumulate") {
        //积累副本箱
        await this.get_case_info();
        await this.$refs.case_reward_ui.getGameInstance();
      } else if (obj.data.boxType == "average") {
        //概率宝箱切换
        if (
          this.awardAverageExtraCases.length >
          Number(obj.awardAverageExtraCaseIndex + 1)
        ) {
          //当前不是最后一个概率宝箱
          this.$nextTick(() => {
            let currentIndex = obj.awardAverageExtraCaseIndex + 1;
            this.awardAverageExtraCases[
              currentIndex
            ].isAwardAverageExtraCaseShow = true;
          });
        } else {
          await this.get_case_info();
        }
      }
    },
    onGameInstanceBox() {
      if (this.gameInstance_info.isGameInstanceOpen) {
        this.unpackgameInstance_item_show = true;
      }
    },
    onUnpackgameInstanceClose(data) {
      //积累宝箱
      let obj = {
        awardAverageExtraCaseIndex: "",
        data: data,
      };
      this.ongameInstanceRewardCloseHandle(obj);
    },
    onGoToMPCList() {
      this.$router.push({
        name: "multiplePeopleCaseList",
        params: { tabType: "all", caseId: this.case_info.caseId },
      });
    },
  },
};
